import { httpClient } from 'core/net/http';
import * as v from 'valibot';
import { LogManager } from 'core/logging/LogManager';
import { OverlayFileInfoSchema } from 'app/business-logic/domain-models/Blasting.schema';

const logger = LogManager.getLogger('uploadOverlayFile', { error: { logToServer: true } });

export async function uploadOverlayFile(overlayFile: File) {
  const formData = new FormData();
  formData.append('overlayFile', overlayFile);

  const response = await httpClient.useInternalApi
    .asAuthorised()
    .post('/configuration/blasting/scenarios/overlays', formData);

  if (!response.isSuccess) {
    const errorMessage = `Failed to upload overlay file "${overlayFile.name}"`;
    logger.error(errorMessage);
    throw new Error(errorMessage);
  }

  const parsedData = v.safeParse(OverlayFileInfoSchema, response.data);

  if (!parsedData.success) {
    const errorMessage = `Failed to parse upload overlay file response for file "${overlayFile.name}"`;
    logger.error(errorMessage, parsedData.issues);
    throw new Error(errorMessage);
  }

  return parsedData.output;
}
